import { Capacitor} from '@capacitor/core';
export function getAPIPath (path)  {
    return  Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios' ?   "https://mewesearcher.com" + path : path
}